import React from 'react'
import { CardAffiliate1 } from './CardAffiliate1';
import { CardAffiliate2 } from './CardAffiliate2';
import { CardAffiliate3 } from './CardAffiliate3';

export const MainCardAffiliate = ({ data }) => {
    return (
        <div className="flex flex-col lg:flex-row gap-4">
            <div className="flex-1">
                <CardAffiliate1 data={data} style={{ minHeight: '255px' }} />
            </div>
            <div className="flex-1">
                <CardAffiliate2 data={data} />
            </div>
            <div className="flex-1">
                <CardAffiliate3 data={data} />
            </div>
        </div>
    )
}
